import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import {
  Breadcrumbs, LinearProgress, Typography,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import PageLayout from '../../PageLayout';
import { deviationActions } from '../../../redux/actions';
import DeviationViewDetail from './DeviationViewDetail';

const DeviationDetailPage = ({ routeParams: { id: deviationId } }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const deviation = useSelector((state) => state.deviation.data);
  const title = intl.formatMessage({ id: 'deviation.title', defaultMessage: 'Desvíos' });
  const deviationDetails = intl.formatMessage({ id: 'deviation.deviationDetails', defaultMessage: 'Detalles' });

  function DeviationDetailBreadcrumbs() {
    return (
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link color="inherit" to="/deviations" style={{ textDecoration: 'none' }}>
          <Typography variant="caption" color="textPrimary" style={{ fontWeight: 400, fontSize: 11 }}>{title}</Typography>
        </Link>
        <Typography variant="caption" color="textPrimary" style={{ fontWeight: 700, fontSize: 11 }}><strong>{deviationDetails}</strong></Typography>
      </Breadcrumbs>
    );
  }

  function DeviationBreadcrumbs() {
    const link = `/deviations/${deviationId}`;
    return (
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link color="inherit" to="/deviations" style={{ textDecoration: 'none' }}>
          <Typography variant="caption" color="textPrimary" style={{ fontWeight: 400, fontSize: 11 }}>{title}</Typography>
        </Link>
        <Link color="inherit" to={link} style={{ textDecoration: 'none' }}>
          <Typography variant="caption" color="textPrimary" style={{ fontWeight: 400, fontSize: 11 }}>{deviation.id}</Typography>
        </Link>
      </Breadcrumbs>
    );
  }

  useEffect(() => {
    dispatch(deviationActions.getDeviations(deviationId));
  }, [deviationId, dispatch]);

  return (
    <>
      {deviation
        ? (
          <PageLayout title={deviation.title} breadCrumbs={<DeviationBreadcrumbs />}>
            <DeviationViewDetail data={deviation} />
          </PageLayout>
        )
        : (
          <PageLayout title={title} breadCrumbs={<DeviationDetailBreadcrumbs />}>
            <LinearProgress />
          </PageLayout>
        )}
    </>
  );
};

DeviationDetailPage.propTypes = {
  routeParams: PropTypes.shape(),
};

DeviationDetailPage.defaultProps = {
  routeParams: {},
};

export default DeviationDetailPage;
